module.exports = __webpack_public_path__ + "static/media/scan.9182ab50.svg";